<template>

	<div id="add_to_planner">

		<div v-if="logged_in" class="vue-btn planner" v-bind:class="{thinking : remove_thinking}" v-on:click.stop="planner_click"><i class="far" v-bind:class="{'fa-calendar-plus': mode==='add', 'fa-times-circle': mode==='remove'}"></i></div>

		<div v-if="logged_in && show_suggest" class="vue-btn suggest" v-bind:class="{thinking : suggest_thinking}" v-on:click.stop="suggest">
			<!-- <i class="far fa-redo"></i> -->Swap
		</div>

		<div v-if="logged_in && show_suggest" class="vue-btn change-day" v-on:click.stop="days_toggle"><i class="far fa-arrows-alt-v"></i></div>

		<div v-show="show_days" class="day-wrapper">
			<div v-on:click.stop="change_day(1)">M</div>
			<div v-on:click.stop="change_day(2)">T</div>
			<div v-on:click.stop="change_day(3)">W</div>
			<div v-on:click.stop="change_day(4)">T</div>
			<div v-on:click.stop="change_day(5)">F</div>
			<div v-on:click.stop="change_day(6)">S</div>
			<div v-on:click.stop="change_day(7)">S</div>
		</div>

		<div class="planner-wrapper" @click="preventPropgation" v-if="logged_in && show_calendar">

			<div class="planner-close" @click.stop="show_calendar = false">Close date picker</div>
			<datepicker v-model="planner_date" :inline="true" :highlighted="highlighted" :monday-first="true" :bootstrap-styling="true" maximum-view="day" v-on:selected="add_to_planner"></datepicker>

		</div>

	</div>

</template>

<script>
	module.exports = {
		name: "PlannerWidget",

		props: {
			post_id_prop: {
				type: Number,
				default: 0,
			},
			date: {
				type: Object,
				default: function () {
					return {};
				},
			},
			mode: {
				type: String,
				default: "add",
			},
			show_suggest: {
				type: Boolean,
				default: false,
			},

			logged_in: {
				type: Boolean,
				default: false,
			},
		},

		mounted() {
			let event = new Event("lc-planner-widget-loaded");
			let el = document.body;
			el.dispatchEvent(event);
		},

		data() {
			return {
				planner_date: null,
				add_thinking: false,
				suggest_thinking: false,
				change_day_thinking: false,
				remove_thinking: false,
				show_calendar: false,
				post_id: this.post_id_prop
					? parseInt(this.post_id_prop)
					: parseInt(pageData.id),
				highlighted: {
					dates: [new Date()],
				},
				show_days: false,
			};
		},

		methods: {
			planner_click() {
				if (this.mode === "add") {
					this.show_calendar = !this.show_calendar;
				} else if (this.mode === "remove") {
					this.remove_from_planner();
				}
			},

			add_to_planner(date) {
				this.add_thinking = true;

				let formattedDate =
					window.DateTime.fromJSDate(date).toFormat("ddMMyyyy");

				window.coreHelpers.ajax.call(
					this,
					"POST",
					"lc_add_post_to_planner",
					{
						date: formattedDate,
						post_id: this.post_id,
					},
					function (res) {
						if (res.success) {
							this.add_thinking = false;
							this.show_calendar = false;
							console.log("LC: post added to planner", res);

							if (res.data.duplicate !== true) {
								coreVariables.triggerModal(
									"Added to planner",
									"This recipe has been added to your weekly planner",
									false,
									null,
									true,
									"Show planner",
									"/planner/"
								);
							} else {
								coreVariables.triggerModal(
									"Already in planner",
									"This recipe has already been added to your weekly planner for this day",
									false,
									null,
									true,
									"Show planner",
									"/planner/"
								);
							}
						} else {
							this.add_thinking = false;
							coreVariables.triggerModal(
								"Slight issue",
								"We can't save to the planner at the moment"
							);
						}
					},
					function (res) {
						this.add_thinking = false;
						coreVariables.triggerModal(
							"Slight issue",
							"We can't save to the planner at the moment"
						);
					}
				);
			},

			remove_from_planner() {
				this.remove_thinking = true;

				window.coreHelpers.ajax.call(
					this,
					"POST",
					"lc_remove_post_from_planner",
					{
						date: this.date,
						post_id: this.post_id,
					},
					function (res) {
						if (res.success) {
							this.remove_thinking = false;
							this.show_calendar = false;

							if (res.data.post) {
								// window.planner.$refs[res.data.post][0].$el.classList.add('deleted');
								this.update_post(res.data.post, res.data.date);
							}

							console.log("LC: post removed from planner", res);
						} else {
							this.remove_thinking = false;
							this.show_calendar = false;
						}
					},
					function (res) {
						this.remove_thinking = false;
						this.show_calendar = false;
					}
				);
			},

			update_post(
				searchPostId = false,
				date = false,
				replacementPost = null
			) {
				if (!searchPostId || !date) {
					return false;
				}

				//loop through the suggested and saved posts and replace or remove
				if (
					coreHelpers.getNested(window, "planner", "saved_posts_by_day")
				) {
					if (
						coreHelpers.getNested(
							window,
							"planner",
							"saved_posts_by_day",
							date["day"]
						) &&
						window.planner.saved_posts_by_day[date["day"]].length
					) {
						window.planner.saved_posts_by_day[date["day"]].forEach(
							(post, index) => {
								if (post["post_id"] == searchPostId) {
									//https://vuejs.org/v2/guide/reactivity.html#For-Arrays

									if (replacementPost) {
										window.planner.saved_posts_by_day[
											date["day"]
										].splice(index, 1, replacementPost);
									} else {
										window.planner.saved_posts_by_day[
											date["day"]
										].splice(index, 1);
									}

									return true;
								}
							}
						);
					}
				}

				//suggested recipes
				if (
					window.planner.suggested_recipes[date["day"]] &&
					window.planner.suggested_recipes[i]["post_id"] == searchPostId
				) {
					// console.log('replacing suggested recipe', window.planner.suggested_recipes[i], replacementPost);
					//https://vuejs.org/v2/guide/reactivity.html#For-Arrays

					if (replacementPost) {
						window.planner.suggested_recipes.splice(
							parseInt(date["day"]),
							1,
							replacementPost
						);
					} else {
						window.planner.suggested_recipes.splice(
							parseInt(date["day"]),
							1
						);
					}

					return true;
				}

				//suggested videos
				if (
					window.planner.suggested_videos[date["day"]] &&
					window.planner.suggested_videos[date["day"]]["post_id"] ==
						searchPostId
				) {
					// console.log('replacing suggested video', window.planner.suggested_videos[video], replacementPost);

					if (replacementPost) {
						// window.planner.suggested_videos[video] = replacementPost;
						window.planner.suggested_videos.splice(
							parseInt(date["day"]),
							1,
							replacementPost
						);
					} else {
						// window.planner.suggested_videos[video] = null;
						window.planner.suggested_videos.splice(
							parseInt(date["day"]),
							1
						);
					}

					return true;
				}

				return false;
			},

			days_toggle() {
				this.show_days = !this.show_days;
			},

			change_day(day_number) {
				if (this.change_day_thinking) return false;

				this.show_days = false;

				this.change_day_thinking = true;

				window.coreHelpers.ajax.call(
					this,
					"POST",
					"lc_change_planner_day",
					{
						current_date: this.date,
						post_id: this.post_id,
						day_number: day_number,
					},
					function (res) {
						if (res.success) {
							this.change_day_thinking = false;

							if (res.data) {
								if (res.data.duplicate) {
									window.vueMessages.addMessage(
										"This item already exists in the target day"
									);
								} else {
									//update the post date

									window.planner.saved_posts_by_day[
										this.date["day"]
									].forEach((post, index) => {
										if (post["post_id"] == this.post_id) {
											let post =
												window.planner.saved_posts_by_day[
													this.date["day"]
												][index];
											post["day"] = day_number;

											//remove from the original day
											window.planner.saved_posts_by_day[
												this.date["day"]
											].splice(index, 1);

											//add to the new day
											window.planner.saved_posts_by_day[
												day_number
											].splice(parseInt(day_number), 1, post);

											return true;
										}
									});
								}
							}
						} else {
							this.change_day_thinking = false;
							window.vueMessages.addMessage(
								"We could not move this item"
							);
						}
					},
					function (res) {
						this.change_day_thinking = false;
						window.vueMessages.addMessage(
							"We could not move this item"
						);
					}
				);
			},

			suggest() {
				this.suggest_thinking = true;

				window.coreHelpers.ajax.call(
					this,
					"POST",
					"lc_planner_single_suggestion",
					{
						date: this.date,
						post_id: this.post_id,
						preferences: coreHelpers.getNested(
							window,
							"pageData",
							"preferences"
						),
						goals: coreHelpers.getNested(window, "pageData", "goals"),
					},
					function (res) {
						if (res.success) {
							this.suggest_thinking = false;
							this.show_calendar = false;

							if (res.data) {
								this.update_post(
									res.data.original_post_id,
									res.data.date,
									res.data.replacement_post
								);
							}
						} else {
							this.suggest_thinking = false;
							window.vueMessages.addMessage(
								"We could not find a replacement"
							);
						}
					},
					function (res) {
						this.suggest_thinking = false;
						window.vueMessages.addMessage(
							"We could not find a replacement"
						);
					}
				);
			},

			preventPropgation(e) {
				e.stopPropagation();
			},
		},
	};
</script>